import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import {
  deactivateScheduledReport,
  getScheduledReports,
  updateScheduledReport,
} from "../api/scheduledReports";
import { UpdateScheduleRequest } from "../types/common";
import { queryClient } from "./client";

export const SCHEDULED_REPORTS_KEY = "scheduledReports";

export function useGetScheduledReports() {
  return useQuery({
    queryKey: SCHEDULED_REPORTS_KEY,
    queryFn: async () => {
      const data = await getScheduledReports();
      return data;
    },
  });
}

export function useUpdateScheduledReport() {
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: UpdateScheduleRequest;
    }) => updateScheduledReport(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries(SCHEDULED_REPORTS_KEY);
      queryClient.refetchQueries(SCHEDULED_REPORTS_KEY);
      toast("Schedule updated successfully", {
        type: "success",
        autoClose: 2000,
      });
    },
    onError: () => {
      toast("Failed to update schedule", { type: "error", autoClose: 2000 });
    },
  });
}

export function useDeactivateScheduledReport() {
  return useMutation({
    mutationFn: (id: string) => deactivateScheduledReport(id),
    onSuccess: () => {
      queryClient.invalidateQueries(SCHEDULED_REPORTS_KEY);
      queryClient.refetchQueries(SCHEDULED_REPORTS_KEY);
      toast("Schedule deactivated", { type: "success", autoClose: 2000 });
    },
    onError: () => {
      toast("Failed to deactivate schedule", {
        type: "error",
        autoClose: 2000,
      });
    },
  });
}
